'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _AccountCircle = _interopRequireDefault(require("@material-ui/icons/AccountCircle"));
var _SidebarMenuItem = _interopRequireDefault(require("Components/Navigation/SidebarMenuItem"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
let app = window.app;
class Sidebar extends _react.Component {
  state = {
    collapses: {}
  };
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.push({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
    if (app.state.session.customized_authorizations?.length > 0) {
      component.handleSessionChange({});
    }
    let collapses = {};
    document.location.pathname.split('/').filter(slug => slug).reduce(function (path, slug) {
      let collapse_url = !path ? '/' + slug : path + '/' + slug;
      collapses[collapse_url] = true;
      return collapse_url;
    }, '');
    component.setState({
      collapses: collapses
    });
  }
  componentWillUnmount() {
    const component = this,
      props = this.props,
      state = this.state;
    app.delete({
      event: 'sessionChange',
      cb: component.handleSessionChange
    });
  }
  handleSessionChange = ({
    source
  }) => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      roles: app.state.session.user.roles
    });
  };
  setLinksData = links => {
    const component = this,
      props = this.props,
      state = this.state;
    const pathname = document.location.pathname.endsWith('/') ? document.location.pathname.slice(0, -1) : document.location.pathname;
    Object.keys(links).forEach(function (name) {
      setSelected(links[name], 0);
    });
    Object.keys(links).forEach(function (name) {
      links[name].selected = links[name].selected || false;
    });
    return links;
    function setSelected(link, level) {
      if (pathname === link.url) {
        link.selected = true;
      } else {
        link.selected = pathname.startsWith(link.url) && pathname.slice(0, link.url.length + 1).endsWith('/');
      }
      link.level = level;
      if (Object.keys(link.sub_items || {}).length > 0) {
        link.open = Boolean(state.collapses[link.url]);
      }
      Object.keys(link.sub_items || {}).forEach(function (name) {
        setSelected(link.sub_items[name], level + 1);
      });
    }
  };
  handleDashBoardMenuClick = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      accomodation_open: !state.accomodation_open
    });
  };
  onClick = (e, link) => {
    let component = this,
      props = this.props,
      state = this.state;
    state.collapses[link.url] = !state.collapses[link.url];
    component.setState({
      collapses: state.collapses
    });
  };
  render = () => {
    const component = this,
      props = this.props,
      state = this.state;
    let configuration_links = {},
      content_links = {};
    if ((state.roles || []).includes('admin')) {
      configuration_links = {
        label: 'Configuration',
        url: '/configuration',
        sub_items: {
          users: {
            url: (0, _Routes.URL)('AdminUsersDashboard', _Routes.front_urls),
            label: 'Utilisateurs'
          },
          sectors: {
            url: (0, _Routes.URL)('AdminSectorsDashboard', _Routes.front_urls),
            label: 'Secteurs'
          },
          company_activities: {
            url: (0, _Routes.URL)('CompanyActivities', _Routes.front_urls),
            label: 'Secteurs d\'activité'
          },
          professional_domains: {
            url: (0, _Routes.URL)('ProfessionalDomains', _Routes.front_urls),
            label: 'Domaines professionnels'
          }
        }
      };
    }
    if ((state.roles || []).includes('admin')) {
      content_links = {
        label: 'Contenu',
        url: '/contenu',
        sub_items: {
          news: {
            url: (0, _Routes.URL)('AdminNewsDashboard', _Routes.front_urls),
            label: 'Actualites'
          },
          blogs: {
            url: (0, _Routes.URL)('AdminBlogsDashboard', _Routes.front_urls),
            label: 'Ressources'
          },
          testimonies: {
            url: (0, _Routes.URL)('TestimoniesDashboardPage', _Routes.front_urls),
            label: 'Témoignages'
          },
          partners: {
            url: (0, _Routes.URL)('PartnersDashboardPage', _Routes.front_urls),
            label: 'Partenaires'
          }
        }
      };
    }
    let links = {
      candidates: {
        url: (0, _Routes.URL)('AdminCandidatesDashboard', _Routes.front_urls),
        label: 'Candidats'
      },
      cvs: {
        url: (0, _Routes.URL)('AdminCVDashboard', _Routes.front_urls),
        label: 'CV'
      },
      companies: {
        url: (0, _Routes.URL)('AdminCompaniesDashboard', _Routes.front_urls),
        label: 'Entreprises'
      },
      jobads_link: {
        url: (0, _Routes.URL)('AdminJobAdsDashboard', _Routes.front_urls),
        label: 'Annonces'
      },
      content: content_links,
      configuration: configuration_links
    };
    if ((state.roles || []).includes('companies-manager')) {
      delete links.candidates;
      delete links.cvs;
    }
    links = component.setLinksData(links);
    const items = Object.keys(links).map(function (name) {
      const link = links[name];
      let output = /*#__PURE__*/_react.default.createElement(_SidebarMenuItem.default, _extends({}, link, {
        key: link.url,
        onClick: (e, data) => component.onClick(e, {
          ...data
        })
      }));
      return output;
    });
    let output = /*#__PURE__*/_react.default.createElement("div", {
      className: 'o-sidebar' + (props.open ? ' o-sidebar--open' : ''),
      id: "sidebar"
    }, /*#__PURE__*/_react.default.createElement(_MenuList.default, null, items));
    return output;
  };
}
exports.default = Sidebar;
